import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { noteRound } from "../../../../util/DoubleUtil";
import TableCellCustom from '../../../UI/TableCellCustom';
import TableCellLeftCustom from '../../../UI/TableCellLeftCustom';
import TableCellRightCustom from '../../../UI/TableCellRightCustom';


export default function RelatorioBoletimNotaBimestreWeb({ boletimEscolar }) {

    return (
        <>
            <Typography
                style={{
                    textAlign: 'center',
                    textDecoration: 'underline'
                }}
                variant="h6">
                Base Comum
            </Typography>
            <Table size="small" aria-label="a dense table"
            // style={{ border: '1px solid black', borderBottom: '1px solid, black' }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell rowSpan={2} style={{}}>Disciplinas</TableCell>
                        <TableCellCustom colSpan={3} >1º Bim.</TableCellCustom>
                        <TableCellCustom colSpan={3} >2º Bim.</TableCellCustom>
                        <TableCellCustom colSpan={3} >3º Bim.</TableCellCustom>
                        <TableCellCustom colSpan={3} >4º Bim.</TableCellCustom>
                        <TableCell rowSpan={2} >5º Con. </TableCell>
                        <TableCell rowSpan={2} >Rec. Int.</TableCell>
                        <TableCell rowSpan={2}>Média Final</TableCell>
                        <TableCell rowSpan={2}>C. H.</TableCell>
                        <TableCell rowSpan={2}>Freq.(%)</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCellLeftCustom>Nota</TableCellLeftCustom>
                        <TableCell>Falta</TableCell>
                        <TableCell>AC</TableCell>
                        <TableCellLeftCustom>Nota</TableCellLeftCustom>
                        <TableCell>Falta</TableCell>
                        <TableCell>AC</TableCell>
                        <TableCellLeftCustom>Nota</TableCellLeftCustom>
                        <TableCell>Falta</TableCell>
                        <TableCell>AC</TableCell>
                        <TableCellLeftCustom>Nota</TableCellLeftCustom>
                        <TableCell>Falta</TableCell>
                        <TableCellRightCustom>AC</TableCellRightCustom>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {boletimEscolar.bnotaBimestres.map((bnb, index) => (
                        <TableRow key={index}>
                            <TableCell>{bnb.tdp.disciplina.descricao}</TableCell>
                            <TableCellLeftCustom>{bnb.mediaBimestral1 && bnb.mediaBimestral1.nota ? noteRound(bnb.mediaBimestral1.nota) : '--'}</TableCellLeftCustom>
                            <TableCell>{bnb.totalFaltas1 ? bnb.totalFaltas1 : '--'}</TableCell>
                            <TableCellRightCustom>{bnb.ausenciaCompensada1 ? bnb.ausenciaCompensada1 : '--'}</TableCellRightCustom>
                            <TableCellLeftCustom>{bnb.mediaBimestral2 && bnb.mediaBimestral2.nota ? noteRound(bnb.mediaBimestral2.nota) : '--'}</TableCellLeftCustom>
                            <TableCell>{bnb.totalFaltas2 ? bnb.totalFaltas2 : '--'}</TableCell>
                            <TableCellRightCustom>{bnb.ausenciaCompensada2 ? bnb.ausenciaCompensada2 : '--'}</TableCellRightCustom>
                            <TableCellLeftCustom>{bnb.mediaBimestral3 && bnb.mediaBimestral3.nota ? noteRound(bnb.mediaBimestral3.nota) : '--'}</TableCellLeftCustom>
                            <TableCell>{bnb.totalFaltas3 ? bnb.totalFaltas3 : '--'}</TableCell>
                            <TableCellRightCustom>{bnb.ausenciaCompensada3 ? bnb.ausenciaCompensada3 : '--'}</TableCellRightCustom>
                            <TableCellLeftCustom>{bnb.mediaBimestral4 && bnb.mediaBimestral4.nota ? noteRound(bnb.mediaBimestral4.nota) : '--'}</TableCellLeftCustom>
                            <TableCell>{bnb.totalFaltas4 ? bnb.totalFaltas4 : '--'}</TableCell>
                            <TableCellRightCustom>{bnb.ausenciaCompensada4 ? bnb.ausenciaCompensada4 : '--'}</TableCellRightCustom>
                            <TableCell>{bnb.quintoConceito && bnb.quintoConceito.nota ? noteRound(bnb.quintoConceito.nota) : '--'}</TableCell>
                            <TableCell>{bnb.recuperacaoIntensiva && bnb.recuperacaoIntensiva.nota ? noteRound(bnb.recuperacaoIntensiva.nota) : '--'}</TableCell>
                            <TableCell>{bnb.mediaFinal && bnb.mediaFinal.nota ? noteRound(bnb.mediaFinal.nota) : '--'}</TableCell>
                            <TableCell>{bnb.totalAulas1 + bnb.totalAulas2 + bnb.totalAulas3 + bnb.totalAulas4}</TableCell>
                            <TableCell>{bnb.frequencia}</TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>

        </>
    );
}